{
  "header": "Detalles del activo",
  "subtitle": "El activo conectado a tu camión (remolque, contenedor, etc.).",
  "assetType": "Tipo de activo",
  "assetTypePlaceholder": "Selecciona el tipo de activo",
  "assetId": "Número de patente, placa o matrícula",
  "assetIdPlaceholder": "P. ej.: número de remolque, ID de contenedor, etc.",
  "remove": "Eliminar",
  "addAnother": "Agregar otro activo",
  "trailerType": "Tipo de remolque",
  "trailerId": "ID del remolque"
}
